/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as VersionsRouteImport } from './../routes/versions'
import { Route as AppishRouteImport } from './../routes/_appish'
import { Route as AppRouteImport } from './../routes/_app'
import { Route as AppIndexRouteImport } from './../routes/_app/index'
import { Route as AppishLogoutRouteImport } from './../routes/_appish/logout'
import { Route as AppUsersRouteImport } from './../routes/_app/users'
import { Route as AppProfileRouteImport } from './../routes/_app/profile'
import { Route as AppNotificationsRouteImport } from './../routes/_app/notifications'
import { Route as AppAuditRouteImport } from './../routes/_app/audit'
import { Route as AppAssetPricingRouteImport } from './../routes/_app/asset-pricing'
import { Route as AppAddressesRouteImport } from './../routes/_app/addresses'
import { Route as AppRedeemIndexRouteImport } from './../routes/_app/redeem/index'
import { Route as AppFundsIndexRouteImport } from './../routes/_app/funds/index'
import { Route as AppRedeemBucketsRouteImport } from './../routes/_app/redeem/buckets'
import { Route as AppFundsAddRouteImport } from './../routes/_app/funds/add'
import { Route as AppExternalFinancialAccountIdRouteImport } from './../routes/_app/external-financial-account/$id'
import { Route as AppCliAuthRouteImport } from './../routes/_app/cli/auth'
import { Route as AppRedeemIdIndexRouteImport } from './../routes/_app/redeem/$id/index'
import { Route as AppFundIdIndexRouteImport } from './../routes/_app/fund/$id/index'
import { Route as AppRedeemIdUnderlyingRouteImport } from './../routes/_app/redeem/$id/underlying'
import { Route as AppRedeemIdLiquidityRouteImport } from './../routes/_app/redeem/$id/liquidity'
import { Route as AppRedeemIdFeesRouteImport } from './../routes/_app/redeem/$id/fees'
import { Route as AppRedeemIdRedemptionIdRouteImport } from './../routes/_app/redeem/$id/$redemptionId'
import { Route as AppFundIdRegistryRouteImport } from './../routes/_app/fund/$id/registry'
import { Route as AppFundIdRecordTransactionRouteImport } from './../routes/_app/fund/$id/record-transaction'
import { Route as AppFundIdNavRouteImport } from './../routes/_app/fund/$id/nav'
import { Route as AppFundIdDexRouteImport } from './../routes/_app/fund/$id/dex'
import { Route as AppFundIdAssetsRouteImport } from './../routes/_app/fund/$id/assets'
import { Route as AppFundIdTokenRecordDepositRouteImport } from './../routes/_app/fund/$id/$token/record-deposit'

const VersionsRoute = VersionsRouteImport.update({
  id: '/versions',
  path: '/versions',
  getParentRoute: () => rootRouteImport,
} as any)
const AppishRoute = AppishRouteImport.update({
  id: '/_appish',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppishLogoutRoute = AppishLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AppishRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAssetPricingRoute = AppAssetPricingRouteImport.update({
  id: '/asset-pricing',
  path: '/asset-pricing',
  getParentRoute: () => AppRoute,
} as any)
const AppAddressesRoute = AppAddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => AppRoute,
} as any)
const AppRedeemIndexRoute = AppRedeemIndexRouteImport.update({
  id: '/redeem/',
  path: '/redeem/',
  getParentRoute: () => AppRoute,
} as any)
const AppFundsIndexRoute = AppFundsIndexRouteImport.update({
  id: '/funds/',
  path: '/funds/',
  getParentRoute: () => AppRoute,
} as any)
const AppRedeemBucketsRoute = AppRedeemBucketsRouteImport.update({
  id: '/redeem/buckets',
  path: '/redeem/buckets',
  getParentRoute: () => AppRoute,
} as any)
const AppFundsAddRoute = AppFundsAddRouteImport.update({
  id: '/funds/add',
  path: '/funds/add',
  getParentRoute: () => AppRoute,
} as any)
const AppExternalFinancialAccountIdRoute =
  AppExternalFinancialAccountIdRouteImport.update({
    id: '/external-financial-account/$id',
    path: '/external-financial-account/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppCliAuthRoute = AppCliAuthRouteImport.update({
  id: '/cli/auth',
  path: '/cli/auth',
  getParentRoute: () => AppRoute,
} as any)
const AppRedeemIdIndexRoute = AppRedeemIdIndexRouteImport.update({
  id: '/redeem/$id/',
  path: '/redeem/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppFundIdIndexRoute = AppFundIdIndexRouteImport.update({
  id: '/fund/$id/',
  path: '/fund/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppRedeemIdUnderlyingRoute = AppRedeemIdUnderlyingRouteImport.update({
  id: '/redeem/$id/underlying',
  path: '/redeem/$id/underlying',
  getParentRoute: () => AppRoute,
} as any)
const AppRedeemIdLiquidityRoute = AppRedeemIdLiquidityRouteImport.update({
  id: '/redeem/$id/liquidity',
  path: '/redeem/$id/liquidity',
  getParentRoute: () => AppRoute,
} as any)
const AppRedeemIdFeesRoute = AppRedeemIdFeesRouteImport.update({
  id: '/redeem/$id/fees',
  path: '/redeem/$id/fees',
  getParentRoute: () => AppRoute,
} as any)
const AppRedeemIdRedemptionIdRoute = AppRedeemIdRedemptionIdRouteImport.update({
  id: '/redeem/$id/$redemptionId',
  path: '/redeem/$id/$redemptionId',
  getParentRoute: () => AppRoute,
} as any)
const AppFundIdRegistryRoute = AppFundIdRegistryRouteImport.update({
  id: '/fund/$id/registry',
  path: '/fund/$id/registry',
  getParentRoute: () => AppRoute,
} as any)
const AppFundIdRecordTransactionRoute =
  AppFundIdRecordTransactionRouteImport.update({
    id: '/fund/$id/record-transaction',
    path: '/fund/$id/record-transaction',
    getParentRoute: () => AppRoute,
  } as any)
const AppFundIdNavRoute = AppFundIdNavRouteImport.update({
  id: '/fund/$id/nav',
  path: '/fund/$id/nav',
  getParentRoute: () => AppRoute,
} as any)
const AppFundIdDexRoute = AppFundIdDexRouteImport.update({
  id: '/fund/$id/dex',
  path: '/fund/$id/dex',
  getParentRoute: () => AppRoute,
} as any)
const AppFundIdAssetsRoute = AppFundIdAssetsRouteImport.update({
  id: '/fund/$id/assets',
  path: '/fund/$id/assets',
  getParentRoute: () => AppRoute,
} as any)
const AppFundIdTokenRecordDepositRoute =
  AppFundIdTokenRecordDepositRouteImport.update({
    id: '/fund/$id/$token/record-deposit',
    path: '/fund/$id/$token/record-deposit',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/versions': typeof VersionsRoute
  '/addresses': typeof AppAddressesRoute
  '/asset-pricing': typeof AppAssetPricingRoute
  '/audit': typeof AppAuditRoute
  '/notifications': typeof AppNotificationsRoute
  '/profile': typeof AppProfileRoute
  '/users': typeof AppUsersRoute
  '/logout': typeof AppishLogoutRoute
  '/': typeof AppIndexRoute
  '/cli/auth': typeof AppCliAuthRoute
  '/external-financial-account/$id': typeof AppExternalFinancialAccountIdRoute
  '/funds/add': typeof AppFundsAddRoute
  '/redeem/buckets': typeof AppRedeemBucketsRoute
  '/funds': typeof AppFundsIndexRoute
  '/redeem': typeof AppRedeemIndexRoute
  '/fund/$id/assets': typeof AppFundIdAssetsRoute
  '/fund/$id/dex': typeof AppFundIdDexRoute
  '/fund/$id/nav': typeof AppFundIdNavRoute
  '/fund/$id/record-transaction': typeof AppFundIdRecordTransactionRoute
  '/fund/$id/registry': typeof AppFundIdRegistryRoute
  '/redeem/$id/$redemptionId': typeof AppRedeemIdRedemptionIdRoute
  '/redeem/$id/fees': typeof AppRedeemIdFeesRoute
  '/redeem/$id/liquidity': typeof AppRedeemIdLiquidityRoute
  '/redeem/$id/underlying': typeof AppRedeemIdUnderlyingRoute
  '/fund/$id': typeof AppFundIdIndexRoute
  '/redeem/$id': typeof AppRedeemIdIndexRoute
  '/fund/$id/$token/record-deposit': typeof AppFundIdTokenRecordDepositRoute
}
export interface FileRoutesByTo {
  '/versions': typeof VersionsRoute
  '/addresses': typeof AppAddressesRoute
  '/asset-pricing': typeof AppAssetPricingRoute
  '/audit': typeof AppAuditRoute
  '/notifications': typeof AppNotificationsRoute
  '/profile': typeof AppProfileRoute
  '/users': typeof AppUsersRoute
  '/logout': typeof AppishLogoutRoute
  '/': typeof AppIndexRoute
  '/cli/auth': typeof AppCliAuthRoute
  '/external-financial-account/$id': typeof AppExternalFinancialAccountIdRoute
  '/funds/add': typeof AppFundsAddRoute
  '/redeem/buckets': typeof AppRedeemBucketsRoute
  '/funds': typeof AppFundsIndexRoute
  '/redeem': typeof AppRedeemIndexRoute
  '/fund/$id/assets': typeof AppFundIdAssetsRoute
  '/fund/$id/dex': typeof AppFundIdDexRoute
  '/fund/$id/nav': typeof AppFundIdNavRoute
  '/fund/$id/record-transaction': typeof AppFundIdRecordTransactionRoute
  '/fund/$id/registry': typeof AppFundIdRegistryRoute
  '/redeem/$id/$redemptionId': typeof AppRedeemIdRedemptionIdRoute
  '/redeem/$id/fees': typeof AppRedeemIdFeesRoute
  '/redeem/$id/liquidity': typeof AppRedeemIdLiquidityRoute
  '/redeem/$id/underlying': typeof AppRedeemIdUnderlyingRoute
  '/fund/$id': typeof AppFundIdIndexRoute
  '/redeem/$id': typeof AppRedeemIdIndexRoute
  '/fund/$id/$token/record-deposit': typeof AppFundIdTokenRecordDepositRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_appish': typeof AppishRouteWithChildren
  '/versions': typeof VersionsRoute
  '/_app/addresses': typeof AppAddressesRoute
  '/_app/asset-pricing': typeof AppAssetPricingRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/users': typeof AppUsersRoute
  '/_appish/logout': typeof AppishLogoutRoute
  '/_app/': typeof AppIndexRoute
  '/_app/cli/auth': typeof AppCliAuthRoute
  '/_app/external-financial-account/$id': typeof AppExternalFinancialAccountIdRoute
  '/_app/funds/add': typeof AppFundsAddRoute
  '/_app/redeem/buckets': typeof AppRedeemBucketsRoute
  '/_app/funds/': typeof AppFundsIndexRoute
  '/_app/redeem/': typeof AppRedeemIndexRoute
  '/_app/fund/$id/assets': typeof AppFundIdAssetsRoute
  '/_app/fund/$id/dex': typeof AppFundIdDexRoute
  '/_app/fund/$id/nav': typeof AppFundIdNavRoute
  '/_app/fund/$id/record-transaction': typeof AppFundIdRecordTransactionRoute
  '/_app/fund/$id/registry': typeof AppFundIdRegistryRoute
  '/_app/redeem/$id/$redemptionId': typeof AppRedeemIdRedemptionIdRoute
  '/_app/redeem/$id/fees': typeof AppRedeemIdFeesRoute
  '/_app/redeem/$id/liquidity': typeof AppRedeemIdLiquidityRoute
  '/_app/redeem/$id/underlying': typeof AppRedeemIdUnderlyingRoute
  '/_app/fund/$id/': typeof AppFundIdIndexRoute
  '/_app/redeem/$id/': typeof AppRedeemIdIndexRoute
  '/_app/fund/$id/$token/record-deposit': typeof AppFundIdTokenRecordDepositRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/versions'
    | '/addresses'
    | '/asset-pricing'
    | '/audit'
    | '/notifications'
    | '/profile'
    | '/users'
    | '/logout'
    | '/'
    | '/cli/auth'
    | '/external-financial-account/$id'
    | '/funds/add'
    | '/redeem/buckets'
    | '/funds'
    | '/redeem'
    | '/fund/$id/assets'
    | '/fund/$id/dex'
    | '/fund/$id/nav'
    | '/fund/$id/record-transaction'
    | '/fund/$id/registry'
    | '/redeem/$id/$redemptionId'
    | '/redeem/$id/fees'
    | '/redeem/$id/liquidity'
    | '/redeem/$id/underlying'
    | '/fund/$id'
    | '/redeem/$id'
    | '/fund/$id/$token/record-deposit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/versions'
    | '/addresses'
    | '/asset-pricing'
    | '/audit'
    | '/notifications'
    | '/profile'
    | '/users'
    | '/logout'
    | '/'
    | '/cli/auth'
    | '/external-financial-account/$id'
    | '/funds/add'
    | '/redeem/buckets'
    | '/funds'
    | '/redeem'
    | '/fund/$id/assets'
    | '/fund/$id/dex'
    | '/fund/$id/nav'
    | '/fund/$id/record-transaction'
    | '/fund/$id/registry'
    | '/redeem/$id/$redemptionId'
    | '/redeem/$id/fees'
    | '/redeem/$id/liquidity'
    | '/redeem/$id/underlying'
    | '/fund/$id'
    | '/redeem/$id'
    | '/fund/$id/$token/record-deposit'
  id:
    | '__root__'
    | '/_app'
    | '/_appish'
    | '/versions'
    | '/_app/addresses'
    | '/_app/asset-pricing'
    | '/_app/audit'
    | '/_app/notifications'
    | '/_app/profile'
    | '/_app/users'
    | '/_appish/logout'
    | '/_app/'
    | '/_app/cli/auth'
    | '/_app/external-financial-account/$id'
    | '/_app/funds/add'
    | '/_app/redeem/buckets'
    | '/_app/funds/'
    | '/_app/redeem/'
    | '/_app/fund/$id/assets'
    | '/_app/fund/$id/dex'
    | '/_app/fund/$id/nav'
    | '/_app/fund/$id/record-transaction'
    | '/_app/fund/$id/registry'
    | '/_app/redeem/$id/$redemptionId'
    | '/_app/redeem/$id/fees'
    | '/_app/redeem/$id/liquidity'
    | '/_app/redeem/$id/underlying'
    | '/_app/fund/$id/'
    | '/_app/redeem/$id/'
    | '/_app/fund/$id/$token/record-deposit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AppishRoute: typeof AppishRouteWithChildren
  VersionsRoute: typeof VersionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/versions': {
      id: '/versions'
      path: '/versions'
      fullPath: '/versions'
      preLoaderRoute: typeof VersionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_appish': {
      id: '/_appish'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppishRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_appish/logout': {
      id: '/_appish/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AppishLogoutRouteImport
      parentRoute: typeof AppishRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/asset-pricing': {
      id: '/_app/asset-pricing'
      path: '/asset-pricing'
      fullPath: '/asset-pricing'
      preLoaderRoute: typeof AppAssetPricingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/addresses': {
      id: '/_app/addresses'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof AppAddressesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/redeem/': {
      id: '/_app/redeem/'
      path: '/redeem'
      fullPath: '/redeem'
      preLoaderRoute: typeof AppRedeemIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/funds/': {
      id: '/_app/funds/'
      path: '/funds'
      fullPath: '/funds'
      preLoaderRoute: typeof AppFundsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/redeem/buckets': {
      id: '/_app/redeem/buckets'
      path: '/redeem/buckets'
      fullPath: '/redeem/buckets'
      preLoaderRoute: typeof AppRedeemBucketsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/funds/add': {
      id: '/_app/funds/add'
      path: '/funds/add'
      fullPath: '/funds/add'
      preLoaderRoute: typeof AppFundsAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/external-financial-account/$id': {
      id: '/_app/external-financial-account/$id'
      path: '/external-financial-account/$id'
      fullPath: '/external-financial-account/$id'
      preLoaderRoute: typeof AppExternalFinancialAccountIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cli/auth': {
      id: '/_app/cli/auth'
      path: '/cli/auth'
      fullPath: '/cli/auth'
      preLoaderRoute: typeof AppCliAuthRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/redeem/$id/': {
      id: '/_app/redeem/$id/'
      path: '/redeem/$id'
      fullPath: '/redeem/$id'
      preLoaderRoute: typeof AppRedeemIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fund/$id/': {
      id: '/_app/fund/$id/'
      path: '/fund/$id'
      fullPath: '/fund/$id'
      preLoaderRoute: typeof AppFundIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/redeem/$id/underlying': {
      id: '/_app/redeem/$id/underlying'
      path: '/redeem/$id/underlying'
      fullPath: '/redeem/$id/underlying'
      preLoaderRoute: typeof AppRedeemIdUnderlyingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/redeem/$id/liquidity': {
      id: '/_app/redeem/$id/liquidity'
      path: '/redeem/$id/liquidity'
      fullPath: '/redeem/$id/liquidity'
      preLoaderRoute: typeof AppRedeemIdLiquidityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/redeem/$id/fees': {
      id: '/_app/redeem/$id/fees'
      path: '/redeem/$id/fees'
      fullPath: '/redeem/$id/fees'
      preLoaderRoute: typeof AppRedeemIdFeesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/redeem/$id/$redemptionId': {
      id: '/_app/redeem/$id/$redemptionId'
      path: '/redeem/$id/$redemptionId'
      fullPath: '/redeem/$id/$redemptionId'
      preLoaderRoute: typeof AppRedeemIdRedemptionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fund/$id/registry': {
      id: '/_app/fund/$id/registry'
      path: '/fund/$id/registry'
      fullPath: '/fund/$id/registry'
      preLoaderRoute: typeof AppFundIdRegistryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fund/$id/record-transaction': {
      id: '/_app/fund/$id/record-transaction'
      path: '/fund/$id/record-transaction'
      fullPath: '/fund/$id/record-transaction'
      preLoaderRoute: typeof AppFundIdRecordTransactionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fund/$id/nav': {
      id: '/_app/fund/$id/nav'
      path: '/fund/$id/nav'
      fullPath: '/fund/$id/nav'
      preLoaderRoute: typeof AppFundIdNavRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fund/$id/dex': {
      id: '/_app/fund/$id/dex'
      path: '/fund/$id/dex'
      fullPath: '/fund/$id/dex'
      preLoaderRoute: typeof AppFundIdDexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fund/$id/assets': {
      id: '/_app/fund/$id/assets'
      path: '/fund/$id/assets'
      fullPath: '/fund/$id/assets'
      preLoaderRoute: typeof AppFundIdAssetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fund/$id/$token/record-deposit': {
      id: '/_app/fund/$id/$token/record-deposit'
      path: '/fund/$id/$token/record-deposit'
      fullPath: '/fund/$id/$token/record-deposit'
      preLoaderRoute: typeof AppFundIdTokenRecordDepositRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAddressesRoute: typeof AppAddressesRoute
  AppAssetPricingRoute: typeof AppAssetPricingRoute
  AppAuditRoute: typeof AppAuditRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCliAuthRoute: typeof AppCliAuthRoute
  AppExternalFinancialAccountIdRoute: typeof AppExternalFinancialAccountIdRoute
  AppFundsAddRoute: typeof AppFundsAddRoute
  AppRedeemBucketsRoute: typeof AppRedeemBucketsRoute
  AppFundsIndexRoute: typeof AppFundsIndexRoute
  AppRedeemIndexRoute: typeof AppRedeemIndexRoute
  AppFundIdAssetsRoute: typeof AppFundIdAssetsRoute
  AppFundIdDexRoute: typeof AppFundIdDexRoute
  AppFundIdNavRoute: typeof AppFundIdNavRoute
  AppFundIdRecordTransactionRoute: typeof AppFundIdRecordTransactionRoute
  AppFundIdRegistryRoute: typeof AppFundIdRegistryRoute
  AppRedeemIdRedemptionIdRoute: typeof AppRedeemIdRedemptionIdRoute
  AppRedeemIdFeesRoute: typeof AppRedeemIdFeesRoute
  AppRedeemIdLiquidityRoute: typeof AppRedeemIdLiquidityRoute
  AppRedeemIdUnderlyingRoute: typeof AppRedeemIdUnderlyingRoute
  AppFundIdIndexRoute: typeof AppFundIdIndexRoute
  AppRedeemIdIndexRoute: typeof AppRedeemIdIndexRoute
  AppFundIdTokenRecordDepositRoute: typeof AppFundIdTokenRecordDepositRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAddressesRoute: AppAddressesRoute,
  AppAssetPricingRoute: AppAssetPricingRoute,
  AppAuditRoute: AppAuditRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppProfileRoute: AppProfileRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppCliAuthRoute: AppCliAuthRoute,
  AppExternalFinancialAccountIdRoute: AppExternalFinancialAccountIdRoute,
  AppFundsAddRoute: AppFundsAddRoute,
  AppRedeemBucketsRoute: AppRedeemBucketsRoute,
  AppFundsIndexRoute: AppFundsIndexRoute,
  AppRedeemIndexRoute: AppRedeemIndexRoute,
  AppFundIdAssetsRoute: AppFundIdAssetsRoute,
  AppFundIdDexRoute: AppFundIdDexRoute,
  AppFundIdNavRoute: AppFundIdNavRoute,
  AppFundIdRecordTransactionRoute: AppFundIdRecordTransactionRoute,
  AppFundIdRegistryRoute: AppFundIdRegistryRoute,
  AppRedeemIdRedemptionIdRoute: AppRedeemIdRedemptionIdRoute,
  AppRedeemIdFeesRoute: AppRedeemIdFeesRoute,
  AppRedeemIdLiquidityRoute: AppRedeemIdLiquidityRoute,
  AppRedeemIdUnderlyingRoute: AppRedeemIdUnderlyingRoute,
  AppFundIdIndexRoute: AppFundIdIndexRoute,
  AppRedeemIdIndexRoute: AppRedeemIdIndexRoute,
  AppFundIdTokenRecordDepositRoute: AppFundIdTokenRecordDepositRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AppishRouteChildren {
  AppishLogoutRoute: typeof AppishLogoutRoute
}

const AppishRouteChildren: AppishRouteChildren = {
  AppishLogoutRoute: AppishLogoutRoute,
}

const AppishRouteWithChildren =
  AppishRoute._addFileChildren(AppishRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AppishRoute: AppishRouteWithChildren,
  VersionsRoute: VersionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
